<div class="overlay">
  <div class="action-container">
    <div
      class="action-icon"
      (click)="toggleRealSize()"
      appTooltip="Taille réelle"
    >
      <mat-icon>crop_original</mat-icon>
    </div>
    <div
      class="action-icon"
      (click)="onClose()"
      appTooltip="Fermer le diaporama"
    >
      <mat-icon>close</mat-icon>
    </div>
  </div>
  <div [class]="imageSizeClass + ' swiper-main-container'">
    <swiper-container
      appSwiper
      #swiper
      class="swiper-main"
      [config]="swiperConfig"
      thumbs-swiper=".swiper-thumbs"
    >
      <swiper-slide *ngFor="let photo of photos; let i = index">
        <div class="swiper-zoom-container">
          <img [src]="photo.url" [alt]="photo.photo.name" loading="lazy" />
        </div>
        <div class="swiper-lazy-preloader"></div>
      </swiper-slide>
    </swiper-container>
    <swiper-container
      appSwiper
      #swiperThumbs
      [config]="swiperThumbsConfig"
      class="swiper-thumbs"
    >
      <swiper-slide *ngFor="let photo of photos; let i = index">
        <img [src]="photo.url" [alt]="photo.photo.name" />
      </swiper-slide>
    </swiper-container>
  </div>
</div>
